import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import "./user.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { communication } from "../../constants/apis/communication";
import toast from "react-hot-toast";
import { useMutation, useQuery } from "react-query";
import Loader from "../../commanComponents/Loader";
import Select from "react-select";
import { getUserDetails } from "../../constants/helpers/getUserDetails";

// Header Icon
const headerIcon = (
  <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="37" height="37" rx="5" fill="#2F3293" />
    <g clip-path="url(#clip0_3065_444688)">
      <path
        d="M18.9511 10.653C19.8016 11.4369 20.3819 12.4219 20.5097 13.6178C20.5622 14.5504 20.4012 15.3667 20.0996 16.2389C20.13 16.2502 20.1604 16.2615 20.1917 16.2732C20.494 16.4115 20.7117 16.6864 20.8455 16.9963C20.9602 17.4951 20.9346 17.9987 20.7097 18.4626C20.4779 18.8524 20.1404 19.2329 19.7288 19.4121C19.6294 19.4733 19.6159 19.5124 19.5811 19.6259C19.5704 19.6592 19.5596 19.6924 19.5486 19.7267C19.5375 19.7624 19.5265 19.7981 19.5151 19.8349C19.3431 20.3529 19.1276 20.7982 18.8101 21.2341C18.6314 21.4796 18.5614 21.686 18.582 21.9968C18.6257 22.0141 18.6257 22.0141 18.6703 22.0317C18.7904 22.0841 18.901 22.1448 19.0147 22.2109C19.059 22.2366 19.1032 22.2623 19.1488 22.2888C19.1965 22.3168 19.2443 22.3447 19.2921 22.3727C19.3165 22.387 19.341 22.4013 19.3662 22.416C19.7908 22.664 20.2115 22.9185 20.6305 23.1766C20.804 23.2833 20.9781 23.3886 21.1528 23.4931C22.9636 24.5763 22.9636 24.5763 23.1757 25.3483C23.211 25.6024 23.2037 25.8603 23.2015 26.1164C23.2016 26.1894 23.2017 26.2624 23.2018 26.3355C23.2019 26.4874 23.2013 26.6394 23.2002 26.7914C23.1988 26.986 23.1991 27.1807 23.1998 27.3754C23.2003 27.5257 23.1999 27.676 23.1993 27.8263C23.1991 27.8981 23.1991 27.9699 23.1993 28.0418C23.1996 28.1418 23.1987 28.2418 23.1976 28.3419C23.1979 28.3714 23.1981 28.4009 23.1984 28.4313C23.1959 28.5655 23.1861 28.6427 23.1074 28.7504C22.9868 28.8492 22.9235 28.8504 22.7716 28.8505C22.6975 28.8512 22.6975 28.8512 22.622 28.852C22.5671 28.8516 22.5122 28.8513 22.4574 28.8509C22.3992 28.8511 22.3409 28.8514 22.2827 28.8518C22.1225 28.8526 21.9624 28.8523 21.8022 28.8519C21.6295 28.8516 21.4568 28.8523 21.2841 28.8528C20.9458 28.8538 20.6075 28.8538 20.2691 28.8534C19.9942 28.8531 19.7193 28.8532 19.4444 28.8535C19.3857 28.8535 19.3857 28.8535 19.3259 28.8536C19.2465 28.8537 19.1671 28.8537 19.0877 28.8538C18.3427 28.8545 17.5977 28.8542 16.8527 28.8534C16.1706 28.8528 15.4886 28.8534 14.8065 28.8547C14.1067 28.8559 13.4068 28.8564 12.7069 28.856C12.6278 28.8559 12.5487 28.8559 12.4696 28.8559C12.4307 28.8558 12.3917 28.8558 12.3516 28.8558C12.077 28.8557 11.8023 28.8561 11.5276 28.8568C11.193 28.8575 10.8584 28.8575 10.5238 28.8565C10.353 28.856 10.1822 28.8559 10.0114 28.8567C9.8551 28.8574 9.69887 28.8572 9.54261 28.8561C9.48598 28.8559 9.42934 28.856 9.37271 28.8566C9.29593 28.8573 9.21914 28.8565 9.14237 28.8557C9.09966 28.8557 9.05695 28.8557 9.01294 28.8557C8.8616 28.8189 8.81908 28.7495 8.73823 28.6139C8.71767 28.4738 8.71767 28.4738 8.71765 28.3131C8.71743 28.2836 8.7172 28.2542 8.71698 28.2238C8.71646 28.1268 8.71714 28.0298 8.71788 27.9328C8.71787 27.8649 8.71781 27.797 8.7177 27.7291C8.71764 27.5867 8.71815 27.4443 8.71909 27.3019C8.72025 27.1206 8.72014 26.9393 8.71962 26.758C8.71933 26.6176 8.71966 26.4772 8.72016 26.3369C8.72035 26.2701 8.72036 26.2033 8.7202 26.1366C8.71944 25.5464 8.77696 25.0479 9.1612 24.591C9.45196 24.3218 9.77282 24.1163 10.1071 23.9116C10.1561 23.8814 10.205 23.8512 10.254 23.821C11.0006 23.3613 11.7517 22.91 12.5064 22.465C12.6381 22.3873 12.7694 22.3089 12.9002 22.2294C12.9272 22.213 12.9543 22.1966 12.9821 22.1797C13.0517 22.1374 13.1211 22.0949 13.1905 22.0523C13.291 21.9968 13.291 21.9968 13.373 21.9968C13.383 21.6517 13.3169 21.4777 13.1016 21.2218C12.7655 20.7838 12.3066 19.9934 12.3066 19.4186C12.2705 19.4076 12.2345 19.3965 12.1973 19.3851C11.7664 19.2202 11.4199 18.8494 11.2169 18.4248C11.0202 17.9461 10.9475 17.4423 11.1158 16.9384C11.256 16.6141 11.4743 16.4044 11.7734 16.2389C11.8005 16.2389 11.8275 16.2389 11.8554 16.2389C11.8396 16.1988 11.8237 16.1586 11.8073 16.1173C11.5868 15.5414 11.429 14.9285 11.4042 14.3053C11.4018 14.2574 11.4018 14.2574 11.3993 14.2085C11.3667 12.9914 11.8429 11.8933 12.6238 11.0112C14.261 9.24278 17.1359 9.065 18.9511 10.653ZM19.8945 16.8405C19.8809 17.3935 19.8674 17.9465 19.8535 18.5163C20.1036 18.2543 20.2603 17.9868 20.3046 17.6139C20.3046 17.3911 20.2581 17.1992 20.1406 17.0124C20.0594 16.9557 19.9781 16.8989 19.8945 16.8405ZM11.8003 17.0253C11.6622 17.1738 11.6459 17.3401 11.635 17.5387C11.6446 17.9144 11.8234 18.2427 12.0605 18.5163C12.074 18.5163 12.0876 18.5163 12.1015 18.5163C12.088 17.9633 12.0744 17.4103 12.0605 16.8405C11.9628 16.8405 11.8696 16.9615 11.8003 17.0253ZM13.7923 18.4348C13.5985 18.5689 13.4749 18.5908 13.2499 18.5593C13.1533 18.4852 13.1533 18.4852 13.0782 18.3847C13.0379 18.3322 13.0379 18.3322 12.9968 18.2786C12.9018 18.1441 12.8085 18.0087 12.7167 17.8718C12.7032 17.8718 12.6897 17.8718 12.6757 17.8718C12.6686 18.1496 12.6906 18.4004 12.7449 18.672C12.7524 18.7095 12.7598 18.747 12.7674 18.7856C13.02 20.0147 13.6435 21.2229 14.6506 21.9462C15.203 22.314 15.7939 22.4847 16.444 22.3378C16.9387 22.1922 17.3437 21.9282 17.7206 21.5671C17.7679 21.5228 17.7679 21.5228 17.8161 21.4776C18.7523 20.5534 19.2385 19.1557 19.2792 17.8288C19.1039 18.002 18.9704 18.2019 18.829 18.4053C18.7228 18.5473 18.6939 18.5547 18.523 18.5807C18.3122 18.578 18.1838 18.4653 18.0142 18.3447C16.7724 17.5172 14.999 17.5608 13.7923 18.4348ZM13.9882 22.2116C13.9517 22.7095 14.151 23.1567 14.4394 23.5436C14.8096 23.9765 15.3051 24.235 15.8575 24.2833C16.4145 24.3041 16.9555 24.1027 17.3672 23.7044C17.7412 23.2824 17.9548 22.788 17.9667 22.2116C17.9279 22.2389 17.9279 22.2389 17.8882 22.2668C17.1504 22.7736 16.4085 23.1066 15.5098 22.9587C14.9541 22.8372 14.4444 22.562 13.9882 22.2116ZM11.3632 23.8874C11.3632 25.3054 11.3632 26.7233 11.3632 28.1843C14.4086 28.1843 17.454 28.1843 20.5917 28.1843C20.5917 26.7805 20.5917 25.3767 20.5917 23.9304C20.1895 23.6698 20.1895 23.6698 19.7842 23.4147C19.7443 23.3899 19.7044 23.3651 19.6633 23.3395C19.5725 23.2791 19.5725 23.2791 19.4843 23.2858C19.4838 23.3473 19.4838 23.3473 19.4833 23.41C19.4801 23.7963 19.4765 24.1826 19.4725 24.5688C19.4705 24.7674 19.4686 24.966 19.467 25.1646C19.4655 25.3563 19.4636 25.548 19.4614 25.7397C19.4607 25.8128 19.46 25.8859 19.4596 25.959C19.4589 26.0614 19.4577 26.1639 19.4564 26.2663C19.4562 26.3116 19.4562 26.3116 19.4561 26.3577C19.4532 26.5342 19.4462 26.7203 19.3203 26.8522C19.233 26.8564 19.1457 26.8575 19.0584 26.8574C19.0307 26.8574 19.0031 26.8575 18.9745 26.8575C18.8812 26.8576 18.7878 26.8573 18.6944 26.8571C18.6277 26.8571 18.561 26.8571 18.4943 26.8571C18.3127 26.8571 18.1311 26.8569 17.9495 26.8566C17.76 26.8563 17.5704 26.8563 17.3808 26.8562C17.0216 26.8561 16.6624 26.8558 16.3031 26.8553C15.8943 26.8548 15.4854 26.8546 15.0766 26.8544C14.2353 26.8539 13.394 26.8532 12.5527 26.8522C12.5034 26.6972 12.5044 26.5546 12.5032 26.3931C12.5028 26.3596 12.5024 26.326 12.502 26.2915C12.5007 26.1806 12.4997 26.0697 12.4987 25.9588C12.4978 25.8819 12.497 25.805 12.4961 25.7281C12.4938 25.5257 12.4918 25.3234 12.4898 25.121C12.4878 24.9145 12.4855 24.708 12.4832 24.5014C12.4788 24.0962 12.4747 23.691 12.4706 23.2858C12.0548 23.2858 11.726 23.6745 11.3632 23.8874Z"
        fill="white"
      />
      <path
        d="M24.6117 14.9066C24.6773 14.9513 24.6773 14.9513 24.7348 15.0355C24.7469 15.1491 24.7519 15.253 24.7514 15.3665C24.7519 15.399 24.7523 15.4315 24.7528 15.465C24.7542 15.5689 24.7548 15.6728 24.7553 15.7767C24.7559 15.913 24.7573 16.0493 24.7591 16.1856C24.759 16.2165 24.7589 16.2475 24.7588 16.2794C24.7626 16.5567 24.8243 16.7501 24.9988 16.9611C25.198 17.1392 25.3481 17.1604 25.606 17.1543C25.7832 17.1335 25.8658 17.0862 26.0063 16.9691C26.1983 16.7095 26.2168 16.444 26.22 16.1269C26.2212 16.0635 26.2223 16.0002 26.2235 15.9369C26.2252 15.8377 26.2267 15.7385 26.2278 15.6393C26.2289 15.5431 26.2308 15.4469 26.2328 15.3507C26.233 15.3211 26.2331 15.2914 26.2332 15.2608C26.2362 15.1394 26.2398 15.0548 26.3061 14.953C26.4032 14.888 26.493 14.8785 26.6066 14.884C27.0511 14.9879 27.4551 15.439 27.7014 15.8231C28.1115 16.5093 28.2284 17.2986 28.0571 18.0863C27.9174 18.5792 27.7134 18.991 27.3326 19.3191C27.137 19.5102 27.0714 19.6717 27.059 19.9505C27.0558 20.0932 27.0583 20.2353 27.0613 20.3779C27.0613 20.4568 27.0611 20.5357 27.0607 20.6146C27.0603 20.7837 27.0613 20.9527 27.0634 21.1218C27.0668 21.3894 27.067 21.6571 27.0668 21.9248C27.0669 22.3483 27.0691 22.7718 27.0722 23.1954C27.0777 23.9535 27.0798 24.7117 27.0808 25.4698C27.0812 25.7356 27.0827 26.0013 27.0849 26.267C27.0862 26.4327 27.0869 26.5983 27.0873 26.764C27.0877 26.8404 27.0884 26.9169 27.0893 26.9933C27.0971 27.6249 27.0143 28.0971 26.5882 28.5667C26.2444 28.9093 25.8349 29.0172 25.3713 29.0123C24.9055 28.9738 24.5638 28.7554 24.2529 28.4042C23.9988 28.0869 23.9078 27.7944 23.9102 27.3844C23.9102 27.3347 23.9102 27.3347 23.9103 27.2841C23.9104 27.1731 23.9108 27.0621 23.9113 26.9511C23.9114 26.8715 23.9115 26.792 23.9116 26.7124C23.9119 26.5411 23.9122 26.3697 23.9126 26.1983C23.9131 25.9273 23.913 25.6563 23.9128 25.3853C23.9128 25.3395 23.9127 25.2938 23.9127 25.2467C23.9126 25.1058 23.9124 24.965 23.9123 24.8241C23.9118 24.2404 23.9117 23.6568 23.9135 23.0732C23.9148 22.6476 23.9149 22.222 23.9137 21.7964C23.9131 21.5711 23.9131 21.346 23.9145 21.1208C23.9158 20.9089 23.9156 20.6971 23.9142 20.4852C23.9139 20.4075 23.9143 20.3298 23.9152 20.2521C23.9328 19.8466 23.9328 19.8466 23.8011 19.4796C23.7192 19.4042 23.6388 19.3476 23.5453 19.2894C23.0785 18.7345 22.8096 18.0073 22.8369 17.2637C22.9034 16.5354 23.1566 15.8521 23.6684 15.3363C24.2515 14.8438 24.2515 14.8438 24.6117 14.9066ZM25.268 22.3402C25.2126 22.4562 25.2208 22.5478 25.2197 22.6777C25.2192 22.7305 25.2187 22.7833 25.2181 22.8377C25.2178 22.8955 25.2175 22.9534 25.2172 23.0113C25.217 23.0404 25.2169 23.0695 25.2167 23.0994C25.2158 23.2534 25.2153 23.4074 25.2149 23.5614C25.2144 23.7204 25.213 23.8795 25.2114 24.0385C25.2103 24.1608 25.21 24.2831 25.2098 24.4054C25.2096 24.464 25.2091 24.5227 25.2084 24.5813C25.2074 24.6634 25.2075 24.7454 25.2077 24.8275C25.2075 24.8742 25.2072 24.9209 25.207 24.969C25.2318 25.1197 25.2753 25.1713 25.391 25.2621C25.518 25.2692 25.518 25.2692 25.6371 25.2191C25.7655 25.0823 25.7757 24.978 25.7761 24.7898C25.7765 24.7379 25.7769 24.686 25.7773 24.6326C25.777 24.5766 25.7768 24.5207 25.7765 24.4631C25.7766 24.405 25.7767 24.3469 25.7769 24.2888C25.7771 24.1672 25.7768 24.0455 25.7762 23.9239C25.7755 23.7681 25.7759 23.6124 25.7767 23.4566C25.7771 23.3367 25.777 23.2167 25.7766 23.0968C25.7765 23.0114 25.7769 22.9261 25.7773 22.8408C25.7769 22.7889 25.7765 22.737 25.7761 22.6835C25.776 22.6379 25.7759 22.5922 25.7758 22.5452C25.7581 22.4104 25.7255 22.3522 25.6371 22.2543C25.483 22.1736 25.3995 22.2397 25.268 22.3402Z"
        fill="white"
      />
      <path
        d="M23.9551 7.00078C24.1597 7.13124 24.2689 7.33159 24.39 7.54107C24.4597 7.654 24.5052 7.72273 24.6289 7.76649C24.7956 7.71077 24.8662 7.58129 24.9651 7.43583C25.0039 7.38032 25.0429 7.32493 25.082 7.26967C25.099 7.24491 25.1159 7.22016 25.1334 7.19466C25.22 7.08669 25.2897 7.04574 25.4228 7.03161C25.5734 7.04547 25.6801 7.08769 25.8181 7.15201C25.8669 7.17469 25.9157 7.19737 25.9659 7.22074C25.991 7.23269 26.016 7.24465 26.0419 7.25696C26.1187 7.29355 26.1959 7.32919 26.2732 7.36475C26.6514 7.54257 26.6514 7.54257 26.7441 7.68828C26.7808 7.98116 26.7244 8.27403 26.672 8.56108C26.6687 8.59919 26.6655 8.63729 26.6621 8.67656C26.7353 8.7728 26.7353 8.7728 26.833 8.76558C26.8691 8.76223 26.9051 8.75889 26.9423 8.75544C26.9818 8.75245 27.0213 8.74946 27.0621 8.74638C27.1453 8.73926 27.2285 8.73177 27.3117 8.72389C27.3514 8.72101 27.391 8.71813 27.4319 8.71516C27.4681 8.71191 27.5043 8.70867 27.5416 8.70532C27.6879 8.72515 27.7485 8.7825 27.8515 8.8914C27.9125 9.00938 27.9125 9.00938 27.9613 9.14351C27.9791 9.19219 27.997 9.24088 28.0154 9.29104C28.0332 9.34173 28.051 9.39241 28.0694 9.44462C28.0881 9.49497 28.1067 9.54532 28.1259 9.5972C28.2813 10.0286 28.2813 10.0286 28.2617 10.2664C28.0933 10.4976 27.8364 10.668 27.6054 10.825C27.5784 10.825 27.5513 10.825 27.5234 10.825C27.5644 11.0675 27.6245 11.1636 27.8148 11.3055C27.8684 11.3433 27.9222 11.381 27.9759 11.4187C28.0013 11.4377 28.0268 11.4567 28.0529 11.4762C28.0762 11.4926 28.0996 11.5089 28.1236 11.5257C28.2147 11.6439 28.2146 11.75 28.2207 11.8992C28.1828 12.0378 28.1828 12.0378 28.1228 12.1778C28.1012 12.2286 28.0796 12.2794 28.0573 12.3318C28.0458 12.3577 28.0343 12.3837 28.0225 12.4105C27.9874 12.4901 27.9536 12.5701 27.9199 12.6503C27.73 13.0894 27.73 13.0894 27.5644 13.1883C27.4447 13.193 27.4447 13.193 27.3106 13.1775C27.2637 13.1726 27.2167 13.1677 27.1684 13.1626C27.0846 13.152 27.0008 13.1411 26.9171 13.1294C26.8324 13.1177 26.7473 13.1097 26.6621 13.1023C26.5622 13.1877 26.5622 13.1877 26.5724 13.3548C26.5756 13.5617 26.5985 13.7654 26.6241 13.9704C26.6203 14.1223 26.5842 14.184 26.498 14.3055C26.3914 14.3693 26.3914 14.3693 26.2643 14.4204C26.218 14.4391 26.1718 14.4578 26.1242 14.4771C26.0516 14.5051 26.0516 14.5051 25.9776 14.5337C25.9301 14.5533 25.8825 14.5728 25.8335 14.5929C25.3681 14.7772 25.3681 14.7772 25.1035 14.7352C25.0158 14.6705 25.0158 14.6705 24.9522 14.5821C24.9292 14.5509 24.9061 14.5197 24.8824 14.4876C24.8606 14.4558 24.8388 14.4241 24.8164 14.3914C24.785 14.3484 24.785 14.3484 24.7529 14.3046C24.6113 14.1067 24.6113 14.1067 24.6113 14.0047C24.5156 13.9901 24.5156 13.9901 24.4062 14.0047C24.3188 14.078 24.3188 14.078 24.2447 14.1792C24.2164 14.2142 24.1882 14.2493 24.159 14.2853C24.1093 14.3505 24.0606 14.4166 24.0139 14.4841C23.9944 14.5111 23.975 14.5381 23.9551 14.566C23.9309 14.6026 23.9309 14.6026 23.9063 14.64C23.7768 14.731 23.6511 14.7189 23.5039 14.6922C23.3232 14.6293 23.1515 14.5493 22.9784 14.4666C22.932 14.4455 22.8856 14.4244 22.8378 14.4026C22.4516 14.2219 22.4516 14.2219 22.3554 14.0477C22.3309 13.7702 22.3834 13.5072 22.4315 13.2344C22.4488 13.1053 22.4488 13.1053 22.3908 13.0191C22.2868 12.957 22.2272 12.9691 22.1093 12.9869C21.9459 13.0069 21.7843 13.0243 21.6197 13.0298C21.5659 13.0322 21.5659 13.0322 21.5109 13.0347C21.3757 13.0097 21.3367 12.9532 21.248 12.8445C21.1613 12.6589 21.0977 12.4638 21.0301 12.2698C21.011 12.2174 20.9918 12.165 20.972 12.111C20.9541 12.0603 20.9363 12.0096 20.9178 11.9573C20.9015 11.9111 20.8851 11.865 20.8683 11.8174C20.834 11.6675 20.8383 11.5742 20.8789 11.4266C20.9657 11.3399 21.0434 11.2719 21.1404 11.201C21.1646 11.1824 21.1888 11.1637 21.2137 11.1446C21.3192 11.064 21.4265 10.9868 21.5351 10.9109C21.567 10.7877 21.567 10.7877 21.5351 10.6531C21.4489 10.5674 21.3737 10.5036 21.2762 10.4356C20.9526 10.2031 20.9526 10.2031 20.8789 10.0086C20.9077 9.70882 21.0355 9.45263 21.1532 9.18144C21.1744 9.13004 21.1956 9.07864 21.2175 9.02568C21.2493 8.95223 21.2493 8.95223 21.2818 8.8773C21.3009 8.83259 21.32 8.78788 21.3396 8.74181C21.4322 8.60359 21.5027 8.58187 21.6582 8.54765C21.7888 8.55806 21.7888 8.55806 21.9222 8.58525C22.1992 8.63799 22.1992 8.63799 22.4785 8.63359C22.5768 8.47913 22.5548 8.41324 22.532 8.23613C22.5174 8.09792 22.5119 7.96157 22.5093 7.82255C22.5082 7.77569 22.5071 7.72883 22.506 7.68055C22.5219 7.53794 22.5384 7.51817 22.6426 7.43046C22.8132 7.34496 22.9913 7.27801 23.1681 7.20756C23.2163 7.18765 23.2646 7.16774 23.3143 7.14722C23.361 7.12842 23.4078 7.10961 23.456 7.09024C23.4986 7.07306 23.5412 7.05588 23.5851 7.03817C23.7163 6.99856 23.8192 6.98905 23.9551 7.00078ZM23.3209 9.90956C23.0559 10.3252 23.0004 10.7255 23.0527 11.2117C23.1558 11.6371 23.4093 12.0376 23.7719 12.2653C24.1611 12.4737 24.5532 12.5242 24.9851 12.4299C25.3609 12.2996 25.6646 12.065 25.8709 11.7089C26.0798 11.2726 26.1514 10.8459 26.0156 10.3723C25.8654 9.98511 25.6121 9.66249 25.2676 9.44999C24.5681 9.14218 23.8134 9.26151 23.3209 9.90956Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3065_444688">
        <rect width="21" height="22" fill="white" transform="translate(8 7)" />
      </clipPath>
    </defs>
  </svg>
);

const calendarIcon = (
  <svg className="premiumDatePickerIcon" style={{ stroke: "#5e3a24" }} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <circle cx="8" cy="14" r="1" />
    <circle cx="12" cy="14" r="1" />
    <circle cx="16" cy="14" r="1" />
    <circle cx="8" cy="18" r="1" />
    <circle cx="12" cy="18" r="1" />
    <circle cx="16" cy="18" r="1" />
  </svg>
);

const downCaretIcon = (
  <svg className="premiumDatePickerCaret" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const reactSelectCustomStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "52px",
    height: "auto",
    borderRadius: "8px",
    border: state.isFocused ? "1.5px solid #2f3299" : "1.5px solid #a2aed6",
    boxShadow: state.isFocused ? "0px 0px 0px 3px rgba(47, 50, 153, 0.1)" : "none",
    padding: "4px 4px",
    fontSize: "15px",
    color: "#2d3748",
    backgroundColor: "#ffffff",
    transition: "border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
    flexWrap: "wrap",
    "&:hover": {
      borderColor: "#2f3299",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    flexWrap: "wrap",
    padding: "4px 8px",
    gap: "4px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    borderRadius: "8px",
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#000",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "rgba(47, 50, 153, 0.1)",
    borderRadius: "4px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#2f3299",
    fontWeight: "500",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#2f3299",
    "&:hover": {
      backgroundColor: "#2f3299",
      color: "white",
    },
  }),
};

const AssignEquipmentToSupervisor = ({ assignmentId: propAssignmentId, isViewMode: propIsViewMode, onClose, mineId: propMineId }) => {
  const {
    register,
    watch,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      user_type: { label: "Contractor", value: "contractor" },
      supervisor: null,
      equipments: [],
      start_date: "",
      end_date: "",
    },
  });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const assignmentId = propAssignmentId !== undefined ? propAssignmentId : searchParams.get("assignmentId");
  const isView = propIsViewMode !== undefined ? propIsViewMode : searchParams.get("page") === "view";
  const mineId = propMineId !== undefined ? propMineId : searchParams.get("mineId") || getUserDetails()?.mineId;

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  const { mutate, isLoading } = useMutation(
    (data) => {
      if (assignmentId) {
        return communication?.updateAssignmentSupervisorEquipment(data);
      } else {
        return communication?.createAssignmentSupervisorEquipment(data);
      }
    },
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (data?.data?.status === "SUCCESS") {
          toast.success(`Success : ${data?.data?.message}`);
          handleClose();
        } else {
          toast.error(`Failed : ${data?.data?.message}`);
        }
      },
      onError: (error) => {
        toast.error(`Failed to update status: ${error?.message}`);
      },
    }
  );

  const { data: equipmentList, isFetching: fetchingEquipment } = useQuery(["getBarcodedEquipmentList"], () => communication?.getCategoryWiseEquipmentList({ mineId }), {
    refetchOnWindowFocus: false,
    select: (data) =>
      data?.data?.data?.map((ele) => ({
        label: `${ele?.category} (${ele?.categoryDescription})`,
        equipmentsCount: ele?.equipments?.length,
        value: ele?.category,
      })),
  });

  const userType = watch("user_type")?.value;

  const { data: supervisorList, isFetching: fetchingSupervisors } = useQuery(["getAllSupervisors", userType, mineId], () => communication.getAllSupervisors({ userType: userType, mineId: mineId }), {
    enabled: !!userType,
    refetchOnWindowFocus: false,
    select: (data) =>
      data?.data?.data?.map((ele) => ({
        label: ele?.name,
        value: ele?._id,
        userType,
        designation: ele?.designation,
        phoneNumber: ele?.phoneNumber,
        realUserType: ele?.userType,
      })) || [],
  });

  const userTypeOptions = [
    { label: "Contractor", value: "contractor" },
    { label: "Departmental", value: "departmental" },
  ];

  const selectedSupervisorId = watch("supervisor")?.value;

  const { data: assignedEquipmentsList, isFetching: fetchingAssignedEquipments } = useQuery(
    ["getCategoryWiseEquipmentListBySupervisor", selectedSupervisorId, mineId],
    () => communication.getCategoryWiseEquipmentListBySupervisor({ supervisorId: selectedSupervisorId, mineId: mineId }),
    {
      enabled: !!selectedSupervisorId,
      refetchOnWindowFocus: false,
    }
  );

  const assignedCategories = assignedEquipmentsList?.data?.data || [];

  const { data: assignmentDetails, isFetching: fetchingAssignmentDetails } = useQuery(["getAssignmentById", assignmentId], () => communication?.getAssignmentById(assignmentId), {
    enabled: !!assignmentId,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (assignmentId && assignmentDetails?.data?.result) {
      const details = assignmentDetails.data.result;

      // 1. Set supervisor
      const supId = details.supervisor?._id;
      const supModel = details.supervisorModel || "Users";
      if (supId) {
        if (supModel === "Contractors") {
          setValue("user_type", { label: "Contractor", value: "contractor" });
        } else {
          setValue("user_type", { label: "Departmental", value: "departmental" });
        }

        const matchedSup = supervisorList?.find((item) => item.value === supId);
        if (matchedSup) {
          setValue("supervisor", matchedSup);
        } else if (details.supervisor) {
          setValue("supervisor", {
            label: `${details.supervisor.name} (${details.supervisor.designation || ""})`,
            value: supId,
            userType: supModel,
            designation: details.supervisor.designation,
            phoneNumber: details.supervisor.phoneNumber,
            realUserType: details.supervisor.userType || (supModel === "Contractors" ? "Contractor" : "Departmental"),
          });
        }
      }

      // 2. Set equipments
      if (details.equipmentCategory && Array.isArray(details.equipmentCategory)) {
        const mappedEquipments = details.equipmentCategory.map((eqCategory) => {
          const found = equipmentList?.find((item) => item.value === eqCategory);
          if (found) return found;
          const catDetail = details.equipmentCategoryDetails?.find((item) => item.category === eqCategory);
          return {
            label: catDetail ? `${catDetail.category} (${catDetail.description || ""})` : eqCategory,
            value: eqCategory,
          };
        });
        setValue("equipments", mappedEquipments);
      }

      // 3. Set dates (format to YYYY-MM-DD for date inputs)
      if (details.fromDate) {
        setValue("start_date", new Date(details.fromDate).toISOString().split("T")[0]);
      }
      if (details.toDate) {
        setValue("end_date", new Date(details.toDate).toISOString().split("T")[0]);
      }
    }
  }, [assignmentId, assignmentDetails, supervisorList, equipmentList, setValue]);

  const submitEquipmentsToSupervisor = (data) => {
    const dataToSend = {
      ...data,
      supervisor_id: data?.supervisor?.value,
      supervisor_model: data?.supervisor?.userType === "departmental" ? "Users" : "Contractors",
      equipment: data?.equipments?.map((ele) => ele?.value),
      mineId,
      user_type: data?.user_type?.value,
    };
    if (assignmentId) {
      dataToSend.id = assignmentId;
    }
    delete dataToSend.supervisor;
    delete dataToSend.equipments;
    mutate(dataToSend);
  };

  const formContent = (
    <div>
      {(isLoading || fetchingAssignmentDetails || fetchingEquipment || fetchingSupervisors) && <Loader />}

      {/* <div className="d-flex justify-content-end mb-2">
        <BackButton />
      </div> */}

      <div className="premiumFormContainer">
        {/* Header */}
        <div className="premiumFormHeader">
          <h2>
            {" "}
            {headerIcon} {isView ? "View Equipment Assignment" : assignmentId ? "Edit Equipment Assignment" : "Assign Equipment to Incharge"}
          </h2>
          <p>Assign a Incharge to manage this equipments</p>
        </div>

        {/* Form Card */}
        <div className="premiumFormCard">
          {isView ? (
            <div style={{ backgroundColor: "#fafbfc", borderRadius: "12px", border: "1px solid #edf2f7", padding: "24px" }}>
              {/* Header */}
              <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "24px", paddingBottom: "20px", borderBottom: "1px solid #e2e8f0", flexWrap: "wrap" }}>
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #2f3299, #5c60f5)",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    boxShadow: "0 4px 10px rgba(47, 50, 153, 0.2)",
                    flexShrink: 0,
                  }}
                >
                  {watch("supervisor")?.label ? watch("supervisor").label.charAt(0) : "S"}
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#1a202c", textTransform: "capitalize" }}>
                    {watch("supervisor")?.label?.split(" (")[0] || "Unknown Supervisor"}
                  </h3>
                  <p style={{ margin: "4px 0 0", fontSize: "14px", color: "#718096", fontWeight: "500", textTransform: "capitalize" }}>
                    {watch("supervisor")?.label?.includes("(") ? watch("supervisor").label.split(" (")[1].replace(")", "") : "Supervisor"}
                  </p>
                </div>
              </div>

              {/* Details Grid */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "24px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <span style={{ fontSize: "12px", color: "#000", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>Designation</span>
                  <strong style={{ fontSize: "15px", color: "#2d3748", fontWeight: "600", textTransform: "capitalize" }}>{watch("supervisor")?.designation || "--"}</strong>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <span style={{ fontSize: "12px", color: "#000", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>Phone Number</span>
                  <strong style={{ fontSize: "15px", color: "#2d3748", fontWeight: "600" }}>{watch("supervisor")?.phoneNumber || "--"}</strong>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <span style={{ fontSize: "12px", color: "#000", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>User Type</span>
                  <strong style={{ fontSize: "15px", color: "#2d3748", fontWeight: "600", textTransform: "capitalize" }}>{watch("supervisor")?.realUserType || "--"}</strong>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "6px", gridColumn: "1 / -1" }}>
                  <span style={{ fontSize: "12px", color: "#000", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>Assigned Equipments Details</span>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "4px" }}>
                    {watch("equipments")?.length > 0 ? (
                      watch("equipments").map((eq, i) => (
                        <span key={i} style={{ backgroundColor: "rgba(47, 50, 153, 0.1)", color: "#2f3299", padding: "6px 12px", borderRadius: "6px", fontSize: "14px", fontWeight: "600" }}>
                          {eq.label}
                        </span>
                      ))
                    ) : (
                      <strong style={{ fontSize: "15px", color: "#2d3748", fontWeight: "600" }}>--</strong>
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <span style={{ fontSize: "12px", color: "#000", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>Assign From Date</span>
                  <strong style={{ fontSize: "15px", color: "#2d3748", fontWeight: "600" }}>{watch("start_date") ? new Date(watch("start_date")).toLocaleDateString("en-GB") : "--"}</strong>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <span style={{ fontSize: "12px", color: "#000", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>Assign To Date</span>
                  <strong style={{ fontSize: "15px", color: "#2d3748", fontWeight: "600" }}>{watch("end_date") ? new Date(watch("end_date")).toLocaleDateString("en-GB") : "--"}</strong>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="premiumFormGrid">
                {/* User Type */}
                <div className="premiumFieldGroup">
                  <label className="premiumFieldLabel">User Type</label>
                  <Controller
                    name="user_type"
                    control={control}
                    rules={{ required: "User Type is Required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isDisabled={isView}
                        options={userTypeOptions}
                        placeholder="Select User Type"
                        styles={reactSelectCustomStyles}
                        onChange={(val) => {
                          field.onChange(val);
                          setValue("supervisor", null);
                        }}
                      />
                    )}
                  />
                  {errors?.user_type && (
                    <span className="text-danger mt-1 d-block" style={{ fontSize: "12px" }}>
                      {errors.user_type.message}
                    </span>
                  )}
                </div>

                {/* Select Supervisor */}
                <div className="premiumFieldGroup">
                  <label className="premiumFieldLabel">Select Incharge</label>
                  <Controller
                    name="supervisor"
                    control={control}
                    rules={{ required: "Incharge is Required" }}
                    render={({ field }) => (
                      <Select {...field} isDisabled={isView} options={supervisorList} isLoading={fetchingSupervisors} placeholder="Select Incharge" styles={reactSelectCustomStyles} />
                    )}
                  />
                  {errors?.supervisor && (
                    <span className="text-danger mt-1 d-block" style={{ fontSize: "12px" }}>
                      {errors.supervisor.message}
                    </span>
                  )}
                </div>

                {/* Select Equipments */}
                <div className="premiumFieldGroup">
                  <label className="premiumFieldLabel">Select Equipments Category</label>
                  <Controller
                    name="equipments"
                    control={control}
                    rules={{ required: "Equipments is Required" }}
                    render={({ field }) => (
                      <Select {...field} isDisabled={isView} options={equipmentList} isLoading={fetchingEquipment} isMulti placeholder="Select Equipments Category" styles={reactSelectCustomStyles} />
                    )}
                  />
                  <span style={{ fontSize: "12px", color: "#718096", marginTop: "4px", fontWeight: "500", fontStyle: "italic" }}>*Note: Only QR Generated Equipments listed here</span>
                  {errors?.equipments && (
                    <span className="text-danger mt-1 d-block" style={{ fontSize: "12px" }}>
                      {errors.equipments.message}
                    </span>
                  )}
                </div>

                {/* Assignment Period */}
                <div className="premiumFieldGroup">
                  <label className="premiumFieldLabel">Assignment Period *</label>
                  <div className="premiumTimePickersRow">
                    {/* From Date */}
                    <div
                      className="premiumDatePickerWrapper"
                      onClick={(e) => {
                        if (isView) return;
                        const input = e.currentTarget.querySelector('input[type="date"]');
                        if (input && typeof input.showPicker === "function") {
                          try {
                            input.showPicker();
                          } catch (err) {
                            console.error(err);
                          }
                        }
                      }}
                    >
                      {calendarIcon}
                      <div className="premiumDatePickerTextGroup">
                        <span className="premiumDatePickerMiniLabel">From</span>
                        <span className="premiumDatePickerValue">{watch("start_date") ? new Date(watch("start_date")).toLocaleDateString("en-GB") : "00/00/0000"}</span>
                      </div>
                      {downCaretIcon}
                      <input
                        type="date"
                        disabled={isView}
                        className="premiumDatePickerInput"
                        min={new Date().toISOString().split("T")[0]}
                        {...register("start_date", { required: "Start Date is Required" })}
                      />
                    </div>

                    {/* To Date */}
                    <div
                      className="premiumDatePickerWrapper"
                      onClick={(e) => {
                        if (isView) return;
                        const input = e.currentTarget.querySelector('input[type="date"]');
                        if (input && typeof input.showPicker === "function") {
                          try {
                            input.showPicker();
                          } catch (err) {
                            console.error(err);
                          }
                        }
                      }}
                    >
                      {calendarIcon}
                      <div className="premiumDatePickerTextGroup">
                        <span className="premiumDatePickerMiniLabel">To</span>
                        <span className="premiumDatePickerValue">{watch("end_date") ? new Date(watch("end_date")).toLocaleDateString("en-GB") : "00/00/0000"}</span>
                      </div>
                      {downCaretIcon}
                      <input
                        type="date"
                        disabled={isView}
                        className="premiumDatePickerInput"
                        min={new Date().toISOString().split("T")[0]}
                        {...register("end_date", { required: "End Date is Required" })}
                      />
                    </div>
                  </div>
                  {(errors?.start_date || errors?.end_date) && (
                    <span className="text-danger mt-1 d-block" style={{ fontSize: "12px" }}>
                      {errors?.start_date?.message || errors?.end_date?.message}
                    </span>
                  )}
                </div>
              </div>

              {/* Show Details when Supervisor is selected at the bottom */}
              {watch("supervisor") && (
                <div
                  style={{
                    marginTop: "32px",
                    backgroundColor: "#f8fafc",
                    padding: "20px",
                    borderRadius: "12px",
                    border: "1px solid #e2e8f0",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                  }}
                >
                  <div style={{ flex: 1, display: "flex", flexWrap: "wrap", gap: "32px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>Designation</span>
                      <strong style={{ fontSize: "15px", color: "#0f172a", fontWeight: "600", textTransform: "capitalize" }}>{watch("supervisor").designation || "--"}</strong>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>Phone Number</span>
                      <strong style={{ fontSize: "15px", color: "#0f172a", fontWeight: "600" }}>{watch("supervisor").phoneNumber || "--"}</strong>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>User Type</span>
                      <strong style={{ fontSize: "15px", color: "#0f172a", fontWeight: "600", textTransform: "capitalize" }}>{watch("supervisor").realUserType || "--"}</strong>
                    </div>
                  </div>

                  {fetchingAssignedEquipments ? (
                    <div style={{ fontSize: "14px", color: "#64748b" }}>Loading assigned equipment categories...</div>
                  ) : assignedCategories.length > 0 ? (
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", paddingTop: "16px", borderTop: "1px solid #e2e8f0" }}>
                      <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>Already Assigned Equipment Categories</span>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                        {assignedCategories.map((cat, idx) => (
                          <span key={idx} style={{ backgroundColor: "rgba(47, 50, 153, 0.1)", color: "#2f3299", padding: "6px 12px", borderRadius: "6px", fontSize: "14px", fontWeight: "600" }}>
                            {cat.category} {cat.categoryDescription ? `(${cat.categoryDescription})` : ""}
                          </span>
                        ))}
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
            </>
          )}
        </div>

        {/* Buttons */}
        <div className="premiumButtonsWrapper">
          {!isView && (
            <button type="button" className="premiumBtnCancel" onClick={handleClose}>
              Cancel
            </button>
          )}

          {!isView && (
            <button type="button" className="premiumBtnSubmit" onClick={() => handleSubmit(submitEquipmentsToSupervisor)()}>
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );

  if (onClose) {
    return (
      <div className="premiumModalOverlay" onClick={handleClose}>
        <div className="premiumModalContent" onClick={(e) => e.stopPropagation()}>
          <button className="premiumModalCloseBtn" onClick={handleClose}>
            &times;
          </button>
          {formContent}
        </div>
      </div>
    );
  }

  return formContent;
};

export default AssignEquipmentToSupervisor;
